import { useState } from "react";
import { Tabela } from "shared/components/table/Tabela";
import { TableColumn } from "types/table/TableColumn";
import RenderRowsProcessosJudiciais from "./RenderRowsProcessosJudiciais";
import { useGetProcessosJudiciaisPaginados } from "hooks/processosJudiciais/useGetProcessosJudiciaisPaginados";
import { useProcessosJudiciaisContext } from "context/gestaoCobranca/ProcessosJudiciaisContext";
import { RequestBuscarProcessoJudicial } from "types/dto/RequestBuscarProcessoJudicial";

const TabelaProcessosJudiciais = () => {
  const [ordenacaoAscOuDesc, setOrdenacaoAscOuDesc] = useState<"ASC" | "DESC">("ASC");
  const [sortString, setSortString] = useState<string>("");
  const [ordenarPorColuna, setOrdenarPorColuna] = useState<string>("condominio");
  const [paginaAtual, setPaginaAtual] = useState(1);

  const { condominioId, numeroProcesso, unidadeSacadoQuery, tipoSituacaoProcessoJudicial } =
    useProcessosJudiciaisContext();

  const params: RequestBuscarProcessoJudicial = {
    size: 10,
    page: paginaAtual - 1,
    sort: sortString,
    condominioId: condominioId,
    numeroProcesso: numeroProcesso,
    situacao: tipoSituacaoProcessoJudicial,
    unidadeSacado: unidadeSacadoQuery,
  };

  const { data: processosJudiciais, isFetching } = useGetProcessosJudiciaisPaginados(params);

  const createColumns = (): TableColumn[] => {
    return [
      {
        id: "unidade.condominio.pessoaJuridica.nomeFantasia",
        label: "Condomínio",
        isOrdenavel: true,
        width: "180px",
      },
      {
        id: "numeroProcesso",
        label: "Número do processo",
        isOrdenavel: true,
        width: "180px",
      },
      {
        id: "unidadeSacado",
        label: "Unidade / Sacado",
        isOrdenavel: true,
        width: "180px",
      },
      {
        id: "situacao",
        label: "Situação",
        isOrdenavel: true,
        width: "180px",
      },
      {
        id: "acoes",
        label: "",
        isOrdenavel: false,
        width: "130px",
      },
    ];
  };

  const ordenarRegistros = (idColuna: string) => {
    const novaOrdenacao =
      !ordenacaoAscOuDesc || ordenarPorColuna !== idColuna || ordenacaoAscOuDesc === "DESC" ? "ASC" : "DESC";
    setOrdenacaoAscOuDesc(novaOrdenacao);
    setOrdenarPorColuna(idColuna);
    setSortString(`${idColuna},${novaOrdenacao}`);
  };

  return (
    <Tabela
      id="tabela-processos-judiciais"
      colunas={createColumns()}
      ordernarPorColuna={ordenarPorColuna}
      ordenacaoAscOuDesc={ordenacaoAscOuDesc}
      ordenarRegistrosFunction={(idColuna) => ordenarRegistros(idColuna)}
      onChangePageFunction={(paginaAtual: number) => setPaginaAtual(paginaAtual)}
      paginaAtual={paginaAtual}
      quantidadeDePaginas={processosJudiciais?.totalPages ?? 0}
      renderCheckBox={false}
      isLoading={isFetching}
      quantidadeDeRegistros={processosJudiciais?.totalElements ?? 0}
    >
      <RenderRowsProcessosJudiciais registros={processosJudiciais?.content || []} />
    </Tabela>
  );
};

export default TabelaProcessosJudiciais;
